var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SloLoader',{attrs:{"loading":_vm.loading}},[(_vm.isOrderable)?_vm._t("default",null,{"product":_vm.product}):_vm._t("not-orderable")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }